import React from "react";
import "./Advantages.css";

const Advantages = () => {
  return (
    <section className="advantages-section">
      
      <h2 className="advantages-title">
        Advantages Of Choosing Amaanat IVF For Fertility Treatment
      </h2>

      <div className="advantages-underline"></div>

      <div className="advantages-grid">

        <div className="adv-item">
          <div className="adv-icon">🧪</div>
          <div>
            <div className="adv-heading">Advanced Medical Treatments</div>
            <div className="adv-text">
              We have expert fertility specialists and cutting-edge techniques
              to ensure the highest chances of success. Our modern facilities
              house the latest diagnostic tools and reproductive techniques.
            </div>
          </div>
        </div>

        <div className="adv-item">
          <div className="adv-icon">🏥</div>
          <div>
            <div className="adv-heading">World-Class Facilities</div>
            <div className="adv-text">
              We’ve established our infrastructure to provide you with a
              relaxing, pleasant experience from start to finish. We commit to
              providing the perfect environment for fertilization and embryo growth.
            </div>
          </div>
        </div>

        <div className="adv-item">
          <div className="adv-icon">👩‍⚕️</div>
          <div>
            <div className="adv-heading">Experienced Specialists</div>
            <div className="adv-text">
              A dedicated team of fertility experts, embryologists, and nurses guarantees top-notch care.
            </div>
          </div>
        </div>

        <div className="adv-item">
          <div className="adv-icon">❤️</div>
          <div>
            <div className="adv-heading">Personalized Care & Emotional Support</div>
            <div className="adv-text">
              Your unique needs are at the forefront of our treatment plans. We provide not just medical care but emotional support throughout your journey.
            </div>
          </div>
        </div>

      </div>
    </section>
  );
};

export default Advantages;